import React, { useState, useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import axios from 'axios';
import Auth from '../components/Auth';
import '../css/DocuCurso.css';

function DocuCurso() {
  const { wp_id } = useParams();
  const location = useLocation();
  const pedidos = location.state ? location.state.pedidos : [];
  const [docuid, setDocuid] = useState([]);
  const [cambiosGuardados, setCambiosGuardados] = useState(false);
  const [pedidosConDocumentacion, setPedidosConDocumentacion] = useState([]);

  useEffect(() => {
    asignarDocumentaciones();
  }, []);

  //Obtiene los ids documentación asignada
  async function asignarDocumentaciones() {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/curso/buscar/${wp_id}`
      );

      const cursoData = response.data.docu_id;
      obtenerDocumentacion(cursoData);
    } catch (error) {
      console.error('Error al obtener el curso:', error);
    }
  }

  //obtiene el listado de documentaciones con nombre e Id como string y lo pasa a number
  async function obtenerDocumentacion(docuIdsCurso) {
    try {

      if (typeof docuIdsCurso === 'string') {
        docuIdsCurso = docuIdsCurso.replace(/[\[\]\s]/g, '').split(',').map(id => Number(id.trim()));
      }
  
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/docu/buscar`
      );
      const docu = response.data;
      let documentacion = {};
      let idsDocumentacion = [];

      docu.forEach((documento) => {
        
        if (docuIdsCurso.includes(Number(documento.id_docu))) {
          documentacion[documento.id_docu] = documento.documentacion;
          idsDocumentacion.push(documento.id_docu); 
        }
      });
       
      setDocuid(idsDocumentacion);
  

      /*-----------------------------------------------------------------------------Esto vamos a intentar hacerlo en donde deberia estar -----------------------------------------------*/
      // Actualizar pedidos con documentación asignada
      const pedidosActualizados = pedidos.map(pedido => ({
        ...pedido,
        asignadas: documentacion,
        recibida: pedido.recibida || [],
        validada: pedido.validada || [], 
      }));
      console.log('pedidosActualizados',pedidosActualizados);
      
      /*-----------------------------------------------------------------------------Esto vamos a intentar hacerlo en donde deberia estar -----------------------------------------------*/
  
      obtenerGestionadas(pedidosActualizados);
  
      return pedidosActualizados;
    } catch (error) {
      console.error('Error al obtener el curso y las documentaciones de los pedidos:', error);
    }
  }
  

  async function obtenerGestionadas(pedidosActualizados) {
    try {
      const pedidosResponse = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/pedido/buscar/${wp_id}`);
      const asignadasPedidos = pedidosResponse.data.pedidos;

      let gestionada = {};

      for (const pedido of pedidosActualizados) {
        for (const subArray of asignadasPedidos) {
          const pedidoGestionado = subArray.find(pedidoGestionado => parseInt(pedidoGestionado.numero_pedido) === parseInt(pedido.numero_pedido));
          if (pedidoGestionado) {

            gestionada[pedidoGestionado.numero_pedido] = {
              recibida: pedidoGestionado.recibida || '',
              validada: pedidoGestionado.validada || '',
            };
            break;
          }
        }
      }

      const pedidosConGestion = pedidosActualizados.map(pedido => {
        const gestionRecibida = gestionada[pedido.numero_pedido] ? gestionada[pedido.numero_pedido].recibida : '';
        const gestionValidada = gestionada[pedido.numero_pedido] ? gestionada[pedido.numero_pedido].validada : '';
        return {
          ...pedido,
          recibida: gestionRecibida,
          validada: gestionValidada,
        };
      });


      setPedidosConDocumentacion(pedidosConGestion);
      descargarDocumentacionCliente(wp_id);
    } catch (error) {
      console.error('Error al obtener las documentaciones gestionadas:', error);
    }
  }

  async function descargarDocumentacionCliente(wp_id) {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/docuwp/buscar/${wp_id}`
      );
      const clienteDocu = response.data.contenido;
  
      setPedidosConDocumentacion(prevPedidos => 
        prevPedidos.map(pedido => {
          // Buscar la documentación para el pedido actual
          const docuCliente = clienteDocu
            .filter(doc => parseInt(doc.pedido) === pedido.numero_pedido)
            .flatMap(doc => doc.documentacion) 
            .map(doc => doc.nombre); 
  
          return {
            ...pedido,
            documentacionCliente: docuCliente.length > 0 ? docuCliente : [], 
          };
        })
      );
  
    } catch (error) {
      console.error('Error al obtener la documentación del cliente', error);
    }
  }
  
  async function descargarDocuCliente(numero_pedido, wp_id, docName) {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/cliente/Docuclientes/${wp_id}/${numero_pedido}/${docName}`,
        { responseType: 'blob' } 
      );
  
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', docName); 
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error('Error al descargar el documento:', error);
    }
  }

  //muestra la fecha con el formato correcto
  const formatoFecha = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString();
  };

  const CambiosEnCheckbox = (pedidoId, documentacionId, tipoEstado) => {
    setPedidosConDocumentacion(prevPedidos => {
      const newPedidos = prevPedidos.map(pedido => {
        if (pedido.id === pedidoId) {
          let newRecibida = [...pedido.recibida];
          let newValidada = [...pedido.validada];
          const index = pedido[tipoEstado].indexOf(documentacionId);

          if (index === -1) {
            if (tipoEstado === 'recibida') {
              newRecibida.push(documentacionId);
            } else {
              newValidada.push(documentacionId);
            }
          } else {
            if (tipoEstado === 'recibida') {
              newRecibida.splice(index, 1);
            } else {
              newValidada.splice(index, 1);
            }
          }
          return {
            ...pedido,
            recibida: tipoEstado === 'recibida' ? newRecibida : pedido.recibida,
            validada: tipoEstado === 'validada' ? newValidada : pedido.validada,
          };
        }
        return pedido;
      });
      return newPedidos;
    });
  };

  async function guardarDatos(numero_pedido, recibida, validada) {
    try {
      const recibidaString = Array.isArray(recibida) ? recibida.join(',') : recibida;
      const validadaString = Array.isArray(validada) ? validada.join(',') : validada;

      await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/pedido/editar`,
        {
          numero_curso: wp_id,
          numero_pedido: numero_pedido,
          asignada: docuid.join(','),
          recibida: recibidaString,
          validada: validadaString
        }
      );

      setCambiosGuardados(true);
    } catch (error) {
      console.error('Error al guardar los cambios:', error);
    }
  }

  const completarPedido = async (idWpPedido) => {
    const confirmar = window.confirm(
      `Estás a punto de completar el pedido con ID: ${idWpPedido}. ¿Quieres continuar?`
    );
  
    if (confirmar) {
      try {
        const response = await axios.put(
          `${process.env.REACT_APP_BACKEND_URL}/pedido/estado/${idWpPedido}`,
          { status: 'completed' }
        );
  
        if (response.data.message && response.data.message.includes('completado exitosamente')) {
          alert(`El pedido ${idWpPedido} se ha completado exitosamente.`);
          
          await eliminarPedidoWp(idWpPedido);
          window.location.href = '/gestion';
          
        } else {
          alert(`No se pudo completar el pedido ${idWpPedido}.`);
        }
      } catch (error) {
        console.error('Error al completar el pedido:', error);
        alert(`Hubo un error al completar el pedido ${idWpPedido}.`);
      }
    } else {
      alert('Acción cancelada.');
    }
  };
  
  const eliminarPedidoWp = async (idWpPedido) => {
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_BACKEND_URL}/pedidowp/borrar/${idWpPedido}`
      );
  
      if (response.status === 200) {
        console.log(`Pedido ${idWpPedido} eliminado correctamente.`);
      } else {
        console.error(`No se pudo eliminar el pedido ${idWpPedido}.`);
      }
    } catch (error) {
      console.error('Error al eliminar el pedido en WordPress:', error);
    }
  };

  pedidosConDocumentacion.forEach(pedido => {
    let Npedido = 22323;
    console.log(`Pedido ${Npedido} - Recibida: ${pedido.recibida}`);
});

  
  return (
    <Auth>
      {({ nombreUsuario, isAdmin, handleLogout }) => (
        <div className='curso_detalle_container'>
          <div>
            <p>Número de pedidos: {pedidosConDocumentacion.length}</p>
            <h2>Detalle de los pedidos realizados del curso</h2>
            <ul>
  {pedidosConDocumentacion.map(pedido => (
    <li key={pedido.id} className='order_item'>
      <div className='order_info'>
        <p>
          Pedido: {pedido.numero_pedido} - Estado: {pedido.estado}<br />
          Producto: {pedido.nombre_producto}<br></br>
          Fecha del pedido: {formatoFecha(pedido.fecha_pedido)} - Cliente: {pedido.nombre_cliente} <br />
          Id del cliente: {pedido.cliente_id}
        </p>
        <div className='documentacion_section'>
          <p>Documentación Necesaria:</p>
          <div className='documentacion_section'>
            {Object.entries(pedido.asignadas).map(([id, documentacion]) => (
              <div key={id} className="documentacion_item">
                <label className='labelDocumentacion' htmlFor={`documentacion_${id}`}>{documentacion}</label>
                <div className='checkbox_section'>
                  <input type='checkbox' id={`documentacion_${id}_recibida`} name={`documentacion_${id}_recibida`}
                    checked={pedido.recibida.includes(id)} 
                    onChange={() => CambiosEnCheckbox(pedido.id, id, 'recibida')} 
                  />
                  Recibida
                  <input type='checkbox' id={`documentacion_${id}_validada`} name={`documentacion_${id}_validada`}
                    checked={pedido.validada.includes(id)} 
                    onChange={() => CambiosEnCheckbox(pedido.id, id, 'validada')} 
                  />
                  Validada
                </div>
                <button
                  onClick={() => {
                    window.open('/alfresco', '_blank');
                  }}
                >
                  Subir
                </button>
              </div>
            ))}
          </div>
          <p>Documentación del Cliente:</p>
          {pedido.documentacionCliente && pedido.documentacionCliente.map((docName, index) => (
            <div key={index}>
              <p>
                <a 
                  href="#"
                  onClick={() => descargarDocuCliente(pedido.numero_pedido, wp_id, docName)} // Llama a la función con los datos necesarios
                >
                  Descargar {docName}
                </a>
              </p>
            </div>
          ))}
        </div>
      </div>
      <div className='divGuardar'>
        <button className='botonGuardar'
          onClick={() => guardarDatos(pedido.numero_pedido, pedido.recibida, pedido.validada)}
        >
          Guardar
        </button>
        <button onClick={() => completarPedido(pedido.numero_pedido)}>
          Completar pedido
        </button>
        {cambiosGuardados && <p>Cambios guardados correctamente</p>}
      </div>
    </li>
  ))}
</ul>
          </div>
        </div>
      )}
    </Auth>
  );

}

export default DocuCurso;